import { FavoriteHeartProvider } from "../../components/FavoriteHeart.tsx";
import { hydrate } from "../hydrate.tsx";
import { SearchResult, type SearchResultProps } from "./SearchResult.tsx";

hydrate<SearchResultProps>("search-results-island", (props) => (
	<FavoriteHeartProvider loginId={props.loginId}>
		<SearchResult {...props} />
	</FavoriteHeartProvider>
));
